import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ScoringLogs = React.lazy(() => import('./index'));
const ScoringLogTable = React.lazy(() => import('./scoringLogTable'));
const ScoringLog = React.lazy(() => import('./scoringLog'));
const ScoringLogDetail = React.lazy(() => import('./scoringLogDetail'));

export const useScoringLogRoutes = () => {

    return (
        <Route path="scoringLogs" element={<Suspense fallback={<div>منتظر باشید...</div>}><ScoringLogs /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ScoringLogTable/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ScoringLog/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ScoringLogDetail/></Suspense> } />
            </Route>
        </Route>
    )
}